import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import MenuIcon from '@material-ui/icons/Menu';

import { CircularProgress, Popover } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';


import Grow from '@material-ui/core/Grow';
import ArticleList from '../article-list';
import PrintIcon from '@material-ui/icons/Print';
import NavigationIcon from '@material-ui/icons/Navigation';
import CheckIcon from '@material-ui/icons/Check';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';


import OrderHelpers from './orderHelpers';

class CardOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextMenuOpen: false,
    };
  }

  get orderHelpers() {
    const {
      value,
      proceedOrder,
      declineOrder,
      showTotalPrice,
      openDeliveryDialog,
      printOrder,
      printing,
      isRoutePlanning,
      addOrderToRoute,
      removeOrderFromRoute,
      isIncludedInRoute,
      localSettings,
      selectOrderForDeliveryTimeInfo,
      classes,
    } = this.props;

    return new OrderHelpers({
      value,
      showTotalPrice,
      proceedOrder,
      declineOrder,
      printOrder,
      openDeliveryDialog,
      printing,
      isRoutePlanning,
      addOrderToRoute,
      removeOrderFromRoute,
      isIncludedInRoute,
      localSettings,
      selectOrderForDeliveryTimeInfo,
      classes,
      handlePopOverClose: () => this.handlePopOverClose(),
    });
  }

  handlePopOverClose() {
    this.setState({ contextMenuOpen: false });
  }

  renderContextMenuButton = () => {
    const { 
      classes, 
      value, 
      printOrder, 
      exportOrder,
      hideActions, 
      printing, 
      exporting,
      isRoutePlanning, 
      addOrderToRoute, 
      removeOrderFromRoute, 
      isIncludedInRoute, 
      localSettings
    } = this.props;

    const { contextMenuOpen, anchorEl } = this.state;

    if (hideActions 
      || isRoutePlanning 
      || (!this.orderHelpers.canSetDelivery() && !this.orderHelpers.showDeliveryExportButton() && !this.orderHelpers.showPrintButton() && !this.orderHelpers.showRoutePlanningButton())) {
      return null;
    }

    if (!this.orderHelpers.canSetDelivery()) {
      return (
        <div className={classes.contextMenuContainer}>
          {this.orderHelpers.showPrintButton() ?
            <Button
              variant="outlined"
              style={this.buttonStyle}
              className={classes.button}
              disabled={value.loading}
              onClick={() => printOrder(value)}
            >
              {printing ?
                <CircularProgress size={20} />
                :
                <PrintIcon />
              }
            </Button >
            : null}
          {localSettings.showOrderExport && value.isDelivery ?
            (
              <Button
                variant="outlined"
                style={this.buttonStyle}
                disabled={value.loading}
                onClick={() => exportOrder(value)}
              >
              {exporting ?
                <CircularProgress size={20} />
                :
                  <LocalShippingIcon />
                }
              </Button >
            ) : null
          }
          {localSettings.enableRouteplanning && value.isDelivery ?
            (
              <Button
                variant="outlined"
                style={this.buttonStyle}
                disabled={value.loading}
                onClick={() => (
                  isIncludedInRoute
                    ? removeOrderFromRoute(value)
                    : addOrderToRoute(value)
                )}
              >
                {isIncludedInRoute ?
                  <CheckIcon />
                  :
                  <NavigationIcon />
                }
              </Button >
            ) : null
          }
        </div>
      );
    }

    return (
      <div className={classes.contextMenuContainer}>
        <Button
          variant="outlined"
          style={this.buttonStyle}
          className={classes.button}
          onClick={e => this.setState({ contextMenuOpen: true, anchorEl: e.currentTarget })}
        >
          <MenuIcon />
        </Button>
        <Popover
          open={contextMenuOpen}
          anchorEl={anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          anchorPosition={{ left: 1, top: 1 }}
          onClose={() => this.setState({ contextMenuOpen: false })}
        >
          {this.orderHelpers.contextMenuItems}
        </Popover>
      </div>
    );
  }

  render() {
    const {
      classes,
      value,
      openDeliveryDialog,
      isRoutePlanning,
      addOrderToRoute,
      removeOrderFromRoute,
      isIncludedInRoute,
      localSettings,
    } = this.props;
    const cardClass = value.loading ? classes.disabledCard : null;

    return (
      <Grow in={value.show}>
        <div className={classes.root} onClick={() => (isRoutePlanning ? isIncludedInRoute ? removeOrderFromRoute(value) : addOrderToRoute(value) : null)}>
          <Card className={cardClass} style={this.orderHelpers.getOrderBackgroundStyle()}>
            <CardContent className={classes.cardContent}>
              <div>
                {this.orderHelpers.renderOrderLoadingIndicator()}
                {this.orderHelpers.renderTakeaway()}
                {this.orderHelpers.renderNotPaid()}
                {this.renderContextMenuButton()}
                <div className={classes.header} onClick={() => !isRoutePlanning && value.isDelivery && openDeliveryDialog(value)}>
                  {this.orderHelpers.renderDispatchEvent()}
                  {this.orderHelpers.renderNickname()}                  
                  {this.orderHelpers.renderPickupCode()}
                  {this.orderHelpers.renderSlotName()}
                  {this.orderHelpers.renderPreOrderTime()}
                  {this.orderHelpers.renderOrderTime()}
                  {this.orderHelpers.renderEventName()}
                  {this.orderHelpers.renderSpotLayoutName()}
                  {this.orderHelpers.renderSpotName()}
                  {this.orderHelpers.renderDeliveryInformation()}
                  {this.orderHelpers.renderTelephone()}
                </div>

                {this.orderHelpers.renderUserNote()}

                <div className={classes.articleList}>
                  <ArticleList
                    value={value.articles}
                    tip={value.tip}
                    showPrices={localSettings.showArticlePrice}
                    showTip={localSettings.showTip}
                  />
                </div>
                {localSettings.showTotalPrice ? this.orderHelpers.renderTotalPrice() : null}
              </div>
            </CardContent>
            {this.orderHelpers.renderOrderActions()}
          </Card>
        </div>
      </Grow>
    );
  }
}

const styles = theme => ({
  contextMenuContainer: {
    float: 'right',
    margin: '10px',
  },
  button: {
    fontSize: theme.order.buttons.fontSize,
    display: 'flex',
    'flex-grow': 1,
  },
  cardContent: {
    padding: 0,
  },
  header: {
    padding: 16,
  },
  headerLabel: {
    display: 'inline-block',
    width: 125,
  },
  headerLabelWide: {
    display: 'inline-block',
    width: 160,
  },
  inlineTypography: {
    display: 'inline-block',
  },
  inlineTypographyDotted: {
    display: 'inline-block',
    textDecoration: 'underline dotted',
    fontSize: 14,
    cursor: 'pointer',
  },
  articleList: {

  },
  totalPriceWrapper: {
    paddingLeft: '16px',
  },
  totalPrice: {
    fontWeight: 'bold',
  },
  userNote: {
    paddingLeft: '16px',
  },
  takeaway: {
    color: '#000',
    fontWeight: 'bold',
    padding: '16px 0 0 16px',
  },
  cardAction: {
    display: 'flex',
  },
  note: {
    padding: '0 16px',
    color: theme.palette.error.dark,
  },
  deliveryInformation: {
  },
});

CardOrder.defaultProps = {
  hideActions: false,
  showTotalPrice: false,
  isRoutePlanning: false,
};

CardOrder.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
  proceedOrder: PropTypes.func.isRequired,
  declineOrder: PropTypes.func.isRequired,
  printOrder: PropTypes.func.isRequired,
  exportOrder: PropTypes.func.isRequired,
  openDeliveryDialog: PropTypes.func.isRequired,
  selectOrderForDeliveryTimeInfo: PropTypes.func.isRequired,
  hideActions: PropTypes.bool,
  isRoutePlanning: PropTypes.bool,
  showTotalPrice: PropTypes.bool,
  localSettings: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardOrder);
